import makeStyles from "@mui/styles/makeStyles";

export const useHeaderEditorStyles = makeStyles({
  headerEditor: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    minHeight: '400px'
  }
});